import routes from './routes.js';
import pages from './pages.js';
import components from './components.js';
import validation from './validation.js';
import message from './message.js';
import enums from './enums.js';

export default {
  routes,
  pages,
  components,
  validation,
  message,
  enums,
};
